import ProductModal from '../components/ProductModal'

class index {
    constructor (components) {
        this._name = this.constructor.name
        this.components = components
        this._mainSlider = components.getComponentsById('mainSlider')
        this._collectionSlider = components.getComponentsById('collectionSlider')
        this._instaFeed = components.getComponentsById('instagramFeed')
        this._afterSlider = this._mainSlider._container.parentElement.parentElement.nextElementSibling
    }

    onInit () {
        window.mSlider = this._mainSlider
        this.mainSlider(this._mainSlider)
        this.collectionSlider(this._collectionSlider)
        this.instaInitCheck(this._instaFeed)
    }

    mainSlider (slider) {
        slider._elem.addEventListener('initiated', e => {
            // moveDots()
            slider.dots.elemContainer.classList.add('ready')
            if (slider.activeSlide.dataset.videoPlayer) {
                slider.video.currentlyPlaying = slider.video.ref[slider.activeSlide.dataset.videoPlayer]
                slider.video.currentlyPlaying.playVideo()
            }
        })
        slider._elem.addEventListener('before-slide', e => {
            slider.dots.elemContainer.classList.remove('ready')
            if (slider.video.currentlyPlaying) {
                slider.video.currentlyPlaying.pauseVideo()
                slider.video.currentlyPlaying = false
            }
        })
        slider._elem.addEventListener('after-slide', e => {
            // moveDots()
            slider.dots.elemContainer.classList.add('ready')
            if (slider.activeSlide.dataset.videoPlayer) {
                slider.video.currentlyPlaying = slider.video.ref[slider.activeSlide.dataset.videoPlayer]
                slider.video.currentlyPlaying.playVideo()
            }
        })
        window.eslider = slider.init()
        let sliderStarted = true
        let afterSliderHit = false
        window.MSLIDER = slider
        window.addEventListener('scroll', e => {
            let afterSliderBox = this._afterSlider.getBoundingClientRect()
            if (afterSliderBox.y <= 0 && sliderStarted && !afterSliderHit) {
                afterSliderHit = true
                slider.stop()
                sliderStarted = false
                slider.attributes.wasStopped = true
                if (slider.activeSlide.dataset.videoPlayer && slider.video.currentlyPlaying) slider.video.currentlyPlaying.pauseVideo()
            }
            if (afterSliderBox.y >= 0 && slider.activeSlide.dataset.videoPlayer && !slider.video.currentlyPlaying && afterSliderHit) {
                afterSliderHit = false
                slider.video.currentlyPlaying = slider.video.ref[slider.activeSlide.dataset.videoPlayer]
                slider.video.currentlyPlaying.playVideo()
                slider.start()
                sliderStarted = true
            }
        })
    }

    collectionSlider (slider) {
        slider._elem.addEventListener('initiated', e => {
            for (let dot of slider.dots.elemDots) {
                dot.addEventListener('click', function (e) {
                    if (slider.activatedDot) return false
                    slider.activatedDot = this
                    this.classList.add('activated')
                })
            }
            for (let slide of slider._slides) {
                slide.productModal = new ProductModal(window.__theme, slide)
                slide.productModal.onInit()
            }
        })
        slider._elem.addEventListener('after-slide', e => {
            if (!slider.activatedDot) return false
            slider.activatedDot.classList.remove('activated')
            slider.activatedDot = false
        })
        window.cslider = slider.init()
    }

    instaInitCheck (compInsta) {
        if (!compInsta._elem) return false
        if (compInsta._elem.instagram.initiated) {
            this.instaInitFires()
            return false
        }
        compInsta._elem.addEventListener('initiated', e => {
            this.instaInitFires()
        })
    }

    instaInitFires () {
        this.addInstaContainer()
    }

    addInstaContainer () {
        let feedContainer = document.createElement('div')
        feedContainer.classList.add('instagram-feed-container')
        feedContainer.appendChild(this._instaFeed.feed)
        this._instaFeed._elem.insertBefore(feedContainer, this._instaFeed._data.nextSibling)
        feedContainer.classList.add('initiated')
    }
}

export default index



// WEBPACK FOOTER //
// ./src/scripts/pages/Index.js